import React, { useState } from 'react';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import Tooltip from 'shared/components/andtComponents/Tooltip';
import Button from 'shared/components/andtComponents/Button';
import Checkbox from 'shared/components/andtComponents/Checkbox';
import DailyHourlySwitchButton from './DailyHourlySwitchButton';
import DownloadChartMenu from './DownloadChartMenu';
import InfoPopover from 'shared/components/andtComponents/InfoPopover/index.jsx';
import NewCustomDashboardPanelModal from 'shared/components/NewCustomDashboardPanelModal.jsx';
import * as custDabrdHelpers from 'usage/containers/CostAndUsageExplorer/helpers/customDashboardHelperMethods.js';
import { v4 } from 'uuid';
import { useRootStore } from 'app/contexts/RootStoreContext.jsx';
import { useSpAnalyzerContext } from 'commitment/containers/spAnalyzerNew/contexts/spAnalyzerContext.jsx';
import styles from './recommendedChart.module.scss';
import classes from '~/recommendationsNew/components/heatMap/heatMapActions/heatMapActions.module.scss';

const getParamsForCustomDashboard = () => ({ id: v4().substring(0, 6).toLowerCase() });

const sparklesIcon = () => <GenerateIcon iconName={ICONS.sparkles.name} className={styles.sparklesIcon} />;
const ChartHeader = ({
  header,
  info,
  exportToCsv,
  exportToPng,
  includeEstimatedOption,
  isDailyMode,
  setIsDailyMode,
  isEstimatedMode,
  setIsEstimatedMode,
  automationid,
  showEvents,
  setShowEvents,
  includeEvents,
  chartType,
  hideDownload = false,
}) => {
  const [dashboardModalIsOpen, setDashboardModalIsOpen] = useState(false);
  const { usageStore } = useRootStore();
  const { existingDashboardsNamesAndIds } = usageStore.customDbSubStore.customDashboardModel;

  const {
    selectedOptions,
    daysToCheck,
    filterStatusType,
    coverage,
    hourlyCommitment,
    excludeExpiringSPsDays,
    isSimulateData,
    selectedPlan,
  } = useSpAnalyzerContext() || {};

  return (
    <div className={styles.headerWrapper}>
      <div className={styles.flex}>
        <span className={styles.header}>{header}</span>
        <Tooltip arrow title={info}>
          <span>
            <GenerateIcon iconName={ICONS.circleInfo.name} className={styles.icon} />
          </span>
        </Tooltip>
        <DailyHourlySwitchButton
          isDailyMode={isDailyMode}
          setIsDailyMode={setIsDailyMode}
          automationid={automationid}
        />
      </div>
      <div className={styles.flex}>
        {includeEvents && (
          <div className={styles.eventWrapper}>
            <Checkbox text="Show Events" isChecked={showEvents} primary onChange={() => setShowEvents(!showEvents)} />
            <InfoPopover isSimple>{'Event of SP Purchase/Expiration'}</InfoPopover>
          </div>
        )}
        {includeEstimatedOption && (
          <Button
            text={
              <Checkbox
                text="Estimated Cost"
                isChecked={!!isEstimatedMode}
                onChange={() => setIsEstimatedMode(!isEstimatedMode)}
                noPaddings
                color="white"
              />
            }
            icon={sparklesIcon}
            iconPlat="right"
          />
        )}
        {!hideDownload && (
          <>
            <Tooltip title="Save as Dashboard Panel" classes={{ tooltip: classes.customTooltip }}>
              <div role="button" onClick={() => setDashboardModalIsOpen(true)} className={styles.itemRow}>
                <GenerateIcon iconName={ICONS.dashboard.name} className={styles.downloadIcon} />
              </div>
            </Tooltip>
            <DownloadChartMenu exportToCsv={exportToCsv} exportToPng={exportToPng} />
          </>
        )}
      </div>
      <NewCustomDashboardPanelModal
        modalIsOpen={dashboardModalIsOpen}
        getCurrentCauParams={getParamsForCustomDashboard}
        onClose={() => {
          setDashboardModalIsOpen(false);
        }}
        customDashboardStore={usageStore.customDbSubStore}
        existingDashboardsNamesAndIds={existingDashboardsNamesAndIds}
        helpers={custDabrdHelpers}
        type={'sp-recommended-chart'}
        state={{
          selectedOptions,
          daysToCheck,
          filterStatusType,
          isSimulateData,
          selectedPlan,
          coverage,
          hourlyCommitment,
          excludeExpiringSPsDays,
          spChartType: chartType,
          isEstimatedMode,
          isDailyMode,
        }}
        isSelectTimePeriodEnabled={false}
        usageStore={usageStore}
      />
    </div>
  );
};

export default ChartHeader;
